/**
 * Coups de pouce — Attendu 673 « Propriétés de la symétrie axiale ».
 *
 * Une entrée par `generator_key` (cf. gen_673.js).
 *
 * Axe (Δ₃) et rayon 11 cm : hors des pools du générateur, dont les axes sont
 * (d) et (Δ) et les rayons vont de 2 à 8 cm.
 *
 * Aucune règle n\'énonce le résultat : la fiche décrit des gestes à faire et
 * des pièges de vocabulaire à surveiller. La figure montre des marques qui se
 * répondent, sans écrire de verdict.
 * Emphase : **texte**, jamais de HTML brut. Pas de tiret cadratin.
 */

const SVG_MARQUES = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 200" role="img"
     aria-label="Un axe vertical bleu partage la figure en deux. En haut a gauche, un triangle ABC ; a droite, son image A prime B prime C prime, retournee. Chaque cote porte le meme nombre de petits traits verts que le cote qui lui correspond, et chaque sommet porte le meme arc orange que le sommet correspondant. En bas a gauche, un cercle de centre O et de rayon 11 centimetres ; a droite, son image de centre O prime, de rayon 11 centimetres egalement.">
  <line x1="180.0" y1="16.0" x2="180.0" y2="176.0" stroke="#378ADD" stroke-width="2.0" stroke-linecap="round"/>
  <text x="180.0" y="11.0" text-anchor="middle" font-size="9.5" font-weight="700" fill="#378ADD">(Δ₃)</text>
  <line x1="60.0" y1="92.0" x2="140.0" y2="92.0" stroke="#0f172a" stroke-width="2.0" stroke-linecap="round"/>
  <line x1="97.8" y1="87.5" x2="97.8" y2="96.5" stroke="#1D9E75" stroke-width="1.8" stroke-linecap="round"/>
  <line x1="102.2" y1="87.5" x2="102.2" y2="96.5" stroke="#1D9E75" stroke-width="1.8" stroke-linecap="round"/>
  <line x1="300.0" y1="92.0" x2="220.0" y2="92.0" stroke="#0f172a" stroke-width="2.0" stroke-linecap="round"/>
  <line x1="262.2" y1="96.5" x2="262.2" y2="87.5" stroke="#1D9E75" stroke-width="1.8" stroke-linecap="round"/>
  <line x1="257.8" y1="96.5" x2="257.8" y2="87.5" stroke="#1D9E75" stroke-width="1.8" stroke-linecap="round"/>
  <line x1="140.0" y1="92.0" x2="95.0" y2="42.0" stroke="#0f172a" stroke-width="2.0" stroke-linecap="round"/>
  <line x1="114.2" y1="70.0" x2="120.8" y2="64.0" stroke="#1D9E75" stroke-width="1.8" stroke-linecap="round"/>
  <line x1="220.0" y1="92.0" x2="265.0" y2="42.0" stroke="#0f172a" stroke-width="2.0" stroke-linecap="round"/>
  <line x1="239.2" y1="64.0" x2="245.8" y2="70.0" stroke="#1D9E75" stroke-width="1.8" stroke-linecap="round"/>
  <line x1="95.0" y1="42.0" x2="60.0" y2="92.0" stroke="#0f172a" stroke-width="2.0" stroke-linecap="round"/>
  <line x1="83.8" y1="65.9" x2="76.4" y2="60.7" stroke="#1D9E75" stroke-width="1.8" stroke-linecap="round"/>
  <line x1="81.2" y1="69.6" x2="73.8" y2="64.4" stroke="#1D9E75" stroke-width="1.8" stroke-linecap="round"/>
  <line x1="78.6" y1="73.3" x2="71.2" y2="68.1" stroke="#1D9E75" stroke-width="1.8" stroke-linecap="round"/>
  <line x1="265.0" y1="42.0" x2="300.0" y2="92.0" stroke="#0f172a" stroke-width="2.0" stroke-linecap="round"/>
  <line x1="283.6" y1="60.7" x2="276.2" y2="65.9" stroke="#1D9E75" stroke-width="1.8" stroke-linecap="round"/>
  <line x1="286.2" y1="64.4" x2="278.8" y2="69.6" stroke="#1D9E75" stroke-width="1.8" stroke-linecap="round"/>
  <line x1="288.8" y1="68.1" x2="281.4" y2="73.3" stroke="#1D9E75" stroke-width="1.8" stroke-linecap="round"/>
  <path d="M 75.0 92.0 A 15.0 15.0 0 0 0 68.6 79.7" fill="none" stroke="#F97316" stroke-width="1.8"/>
  <path d="M 291.4 79.7 A 15.0 15.0 0 0 0 285.0 92.0" fill="none" stroke="#F97316" stroke-width="1.8"/>
  <path d="M 130.0 80.9 A 15.0 15.0 0 0 0 125.0 92.0" fill="none" stroke="#F97316" stroke-width="1.8"/>
  <path d="M 235.0 92.0 A 15.0 15.0 0 0 0 230.0 80.9" fill="none" stroke="#F97316" stroke-width="1.8"/>
  <path d="M 86.4 54.3 A 15.0 15.0 0 0 0 105.0 53.1" fill="none" stroke="#F97316" stroke-width="1.8"/>
  <path d="M 255.0 53.1 A 15.0 15.0 0 0 0 273.6 54.3" fill="none" stroke="#F97316" stroke-width="1.8"/>
  <circle cx="60.0" cy="92.0" r="3.0" fill="#0f172a"/>
  <text x="52.0" y="100.0" text-anchor="end" font-size="10.5" font-weight="700" fill="#0f172a">A</text>
  <circle cx="300.0" cy="92.0" r="3.0" fill="#0f172a"/>
  <text x="308.0" y="100.0" text-anchor="start" font-size="10.5" font-weight="700" fill="#0f172a">A′</text>
  <circle cx="140.0" cy="92.0" r="3.0" fill="#0f172a"/>
  <text x="148.0" y="100.0" text-anchor="start" font-size="10.5" font-weight="700" fill="#0f172a">B</text>
  <circle cx="220.0" cy="92.0" r="3.0" fill="#0f172a"/>
  <text x="212.0" y="100.0" text-anchor="end" font-size="10.5" font-weight="700" fill="#0f172a">B′</text>
  <circle cx="95.0" cy="42.0" r="3.0" fill="#0f172a"/>
  <text x="95.0" y="33.0" text-anchor="middle" font-size="10.5" font-weight="700" fill="#0f172a">C</text>
  <circle cx="265.0" cy="42.0" r="3.0" fill="#0f172a"/>
  <text x="265.0" y="33.0" text-anchor="middle" font-size="10.5" font-weight="700" fill="#0f172a">C′</text>
  <circle cx="100.0" cy="142.0" r="26.0" fill="none" stroke="#0f172a" stroke-width="2.0"/>
  <line x1="100.0" y1="142.0" x2="126.0" y2="142.0" stroke="#1D9E75" stroke-width="2.0" stroke-linecap="round"/>
  <text x="113.0" y="136.0" text-anchor="middle" font-size="8.5" font-weight="700" fill="#1D9E75">11 cm</text>
  <circle cx="100.0" cy="142.0" r="3.5" fill="#9333EA"/>
  <circle cx="260.0" cy="142.0" r="26.0" fill="none" stroke="#0f172a" stroke-width="2.0"/>
  <line x1="260.0" y1="142.0" x2="234.0" y2="142.0" stroke="#1D9E75" stroke-width="2.0" stroke-linecap="round"/>
  <text x="247.0" y="136.0" text-anchor="middle" font-size="8.5" font-weight="700" fill="#1D9E75">11 cm</text>
  <circle cx="260.0" cy="142.0" r="3.5" fill="#9333EA"/>
  <text x="94.0" y="156.0" text-anchor="end" font-size="10.5" font-weight="700" fill="#9333EA">O</text>
  <text x="267.0" y="156.0" text-anchor="start" font-size="10.5" font-weight="700" fill="#9333EA">O′</text>
  <text x="180.0" y="192.0" text-anchor="middle" font-size="8.5" font-weight="600" fill="#64748b">les mêmes marques se retrouvent de chaque côté de l'axe</text>
</svg>`.trim();

const CP_673 = {
    // Pas de page de règles : la figure porte seule le mini-cours. Elle montre
    // des marques qui se répondent de part et d\'autre de l\'axe, sans écrire
    // aucun verdict — c\'est à l\'élève de conclure.
    nature_figure_image_qcm: {
        pages: [
            { titre: 'Un exemple', svg: SVG_MARQUES },
        ],
    },

    // Pas de figure non plus ici : SVG_MARQUES écrit la MÊME mesure de rayon de
    // part et d\'autre de l\'axe, ce qui est exactement la réponse de la seconde
    // variante. Les règles font manipuler à la place.
    cercle_image_qcm: {
        pages: [
            { titre: 'La règle', lignes: [
                'Un cercle est décrit par **deux choses** : la position de son centre, et la longueur de son rayon. Traite-les l\'une après l\'autre.',
                'Le centre est un **point** : par une symétrie, un point reste-t-il sur place ? Souviens-toi du seul cas où cela arrive.',
                'Le rayon est une **longueur**. Plie la feuille le long de l\'axe et superpose le cercle à son image : cette longueur a-t-elle bougé ?',
                'Demande-toi enfin si la **position de l\'axe** peut changer quoi que ce soit à ta réponse.',
            ] },
        ],
    },

    // Pas de figure : l\'exercice demande de retrouver un ORDRE, et toute image
    // du déroulé le donnerait. Les règles n\'énoncent que des dépendances — ce
    // dont chaque étape a besoin pour être possible.
    etapes_construction_triangle_ordonner: {
        pages: [
            { titre: 'La règle', lignes: [
                'Une étape ne peut venir qu\'après celle qui produit ce dont elle a besoin : cherche, dans chacune, ce qui doit **déjà exister** pour qu\'elle soit possible.',
                'Un point noté avec un **prime** n\'existe pas tant qu\'on ne l\'a pas construit : une étape qui en parle suppose donc ce travail déjà fait.',
                'On ne relie que des points **déjà placés**.',
            ] },
        ],
    },
};

export default CP_673;
